export default 'https://tme.understood.org/assets/book.5177b996.jpg'